// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/HsvSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/HsvSans-Bold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/HsvSans-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/HsvSans-Book-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/HsvSans-Extrabold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/HsvSans-Extrabold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/HsvSans-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/HsvSans-Heavy-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/HsvSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/HsvSans-Light-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/HsvSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/HsvSans-Medium-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/HsvSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/HsvSans-Regular-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/HsvSans-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/HsvSans-Semibold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/HsvSans-Ultrabold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/HsvSans-Ultrabold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/HsvSlab-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/HsvSlab-Bold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/HsvSlab-Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/HsvSlab-Book-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/HsvSlab-Extrabold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/HsvSlab-Extrabold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/HsvSlab-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/HsvSlab-Heavy-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/HsvSlab-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/HsvSlab-Light-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/HsvSlab-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/HsvSlab-Medium-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../fonts/HsvSlab-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../fonts/HsvSlab-Regular-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../fonts/HsvSlab-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../fonts/HsvSlab-Semibold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../fonts/HsvSlab-Ultrabold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../fonts/HsvSlab-Ultrabold-Italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
    font-weight: 800;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
    font-weight: 800;
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
    font-weight: 900;
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
    font-weight: 300;
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
    font-weight: 500;
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
    font-weight: 600;
    font-style: italic;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype");
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: "HsvSans";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype");
    font-weight: 900;
    font-style: italic;
}

/* HsvSlab Fonts */
@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("truetype");
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype");
    font-weight: 800;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
    font-weight: 800;
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype");
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("truetype");
    font-weight: 900;
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype");
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype");
    font-weight: 300;
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype");
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype");
    font-weight: 500;
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype");
    font-weight: 400; /* or normal */
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype");
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("truetype");
    font-weight: 600;
    font-style: italic;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype");
    font-weight: 900;
    font-style: normal;
}

@font-face {
    font-family: "HsvSlab";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("truetype");
    font-weight: 900;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,+DAAwD;IACxD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAA+D;IAC/D,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAwD;IACxD,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAA+D;IAC/D,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAoE;IACpE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAyD;IACzD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAgE;IAChE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAyD;IACzD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+DAAgE;IAChE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA0D;IAC1D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAiE;IACjE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA2D;IAC3D,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAkE;IAClE,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA4D;IAC5D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAmE;IACnE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAoE;IACpE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,gEAAwD;IACxD,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA+D;IAC/D,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAwD;IACxD,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA+D;IAC/D,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAoE;IACpE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAyD;IACzD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAgE;IAChE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAyD;IACzD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAgE;IAChE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA0D;IAC1D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAiE;IACjE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA2D;IAC3D,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAkE;IAClE,gBAAgB,EAAE,cAAc;IAChC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA4D;IAC5D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAmE;IACnE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gEAAoE;IACpE,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Bold.ttf\") format(\"truetype\");\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Bold-Italic.ttf\") format(\"truetype\");\n    font-weight: bold;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Book.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Book-Italic.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Extrabold.ttf\") format(\"truetype\");\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Extrabold-Italic.ttf\") format(\"truetype\");\n    font-weight: 800;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Heavy.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Heavy-Italic.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Light.ttf\") format(\"truetype\");\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Light-Italic.ttf\") format(\"truetype\");\n    font-weight: 300;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Medium.ttf\") format(\"truetype\");\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Medium-Italic.ttf\") format(\"truetype\");\n    font-weight: 500;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Regular.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Regular-Italic.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Semibold.ttf\") format(\"truetype\");\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Semibold-Italic.ttf\") format(\"truetype\");\n    font-weight: 600;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Ultrabold.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSans\";\n    src: url(\"../fonts/HsvSans-Ultrabold-Italic.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: italic;\n}\n\n/* HsvSlab Fonts */\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Bold.ttf\") format(\"truetype\");\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Bold-Italic.ttf\") format(\"truetype\");\n    font-weight: bold;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Book.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Book-Italic.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Extrabold.ttf\") format(\"truetype\");\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Extrabold-Italic.ttf\") format(\"truetype\");\n    font-weight: 800;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Heavy.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Heavy-Italic.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Light.ttf\") format(\"truetype\");\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Light-Italic.ttf\") format(\"truetype\");\n    font-weight: 300;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Medium.ttf\") format(\"truetype\");\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Medium-Italic.ttf\") format(\"truetype\");\n    font-weight: 500;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Regular.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Regular-Italic.ttf\") format(\"truetype\");\n    font-weight: 400; /* or normal */\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Semibold.ttf\") format(\"truetype\");\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Semibold-Italic.ttf\") format(\"truetype\");\n    font-weight: 600;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Ultrabold.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"HsvSlab\";\n    src: url(\"../fonts/HsvSlab-Ultrabold-Italic.ttf\") format(\"truetype\");\n    font-weight: 900;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
